export default __webpack_public_path__ + "static/media/NunettineScone.8ae71d7b.png";